import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { Dispatch, SetStateAction, useEffect } from "react";
import { AllStats, OverviewStat, PlayerColorInfo, StatValue } from "src/components/types";
import "./EndgameRedirectDialog.css";
import { isColorDark, stripWidthFromStyle } from "./utility";
import { getCgoColor } from "../../playerColors";
import { UsernameDisplay } from "src/components/pages/UserPage";
import { useParams } from "react-router-dom";

type EndgameRedirectDialogProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  switchToFeedback: () => void;
  switchToScoring: () => void;
  allStats: AllStats;
  overviewStats?: OverviewStat[];
  playerColors: PlayerColorInfo[];
};

export function EndgameRedirectDialog({
  isOpen,
  setIsOpen,
  switchToFeedback,
  switchToScoring,
  allStats,
  playerColors,
  overviewStats,
}: EndgameRedirectDialogProps) {
  let showScoreTitle = false;
  let resultsGrid = <></>;
  let params = useParams();
  if (allStats && allStats.playerStats && playerColors) {
    showScoreTitle = true;
    if (overviewStats) {
      overviewStats = overviewStats.filter((stat) =>
        playerColors.find((c) => allStats.playerStats[stat.name]?.[c.color]),
      );
    }
    resultsGrid = (
      <table className="endgame-dialog-results-table">
        <thead>
          <tr>
            <th key="topleftempty">{"\u00A0" /* topleft empty cell */}</th>
            {playerColors.map((playerColorInfo) => {
              return (
                <th>
                  <UsernameDisplay
                    color={getCgoColor(playerColorInfo.color)}
                    username={playerColorInfo.userInfo?.username ?? "dummy-" + playerColorInfo.color}
                  ></UsernameDisplay>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {overviewStats?.map((stat) => {
            let strippedWidthStyle = {};
            if (stat.customStyle) {
              strippedWidthStyle = stripWidthFromStyle(stat.customStyle);
            }
            return (
              <tr key={"endgame-row-" + stat.name}>
                <th key={"endgame-row-desc-" + stat.name}>{stat.displayName ?? stat.name}</th>
                {playerColors.map((playerColorInfo) => {
                  return (
                    <td style={strippedWidthStyle}>
                      {allStats.playerStats[stat.name]?.[playerColorInfo.color] ?? "-"}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} aria-describedby="alert-dialog-description">
      <DialogContent>
        <DialogContentText id="alert-dialog-description" component={"div"}>
          <Typography gutterBottom>The game has ended.</Typography>
          {showScoreTitle ? (
            <Typography gutterBottom sx={{ fontWeight: "600" }}>
              Results
            </Typography>
          ) : null}
          {resultsGrid}
          <Divider flexItem />
          <Typography gutterBottom>
            It would be greatly appreciated if you could share any feedback you have, as this helps improve the game.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={switchToFeedback} autoFocus>
          Go to feedback
        </Button>
        <Button onClick={switchToScoring}>View full stats</Button>
        <Button onClick={() => setIsOpen(false)}>Not right now</Button>
      </DialogActions>
    </Dialog>
  );
}
